'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);
var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');
var serverData = (typeof window !== "undefined" ? window.pbizServer : typeof global !== "undefined" ? global.pbizServer : null);
var focalPoint = require('focal-point');

var appDom = require('./app-dom');

var showErrorMessage = function(options) {

	notify.show($.extend({closeOnClick: true}, options));

	window.addEventListener('resize', function() {

		notify.hide();
		
	}, {once: true});

};

var routeSuccessfulLogin = function(loginDirective) {

	window.location = loginDirective;

};

var attemptLogin = function() {

	var endpoint = serverData.root;

	if (document.forms.eventLoginForm.dataset.contactCreation) {

		endpoint += '?page=event_login_account_creation_action';

		serverData.confirm = document.forms.eventLoginForm.confirm.checked;

		if (document.forms.eventLoginForm.policy) {

			serverData.policy = document.forms.eventLoginForm.policy.checked;

		}

		if (document.forms.eventLoginForm.marketing) {

			serverData.marketing = document.forms.eventLoginForm.marketing.checked;

		}

	} else {

		endpoint += '?page=event_login_action';

		if (document.forms.eventLoginForm.password) {

			serverData.password = document.forms.eventLoginForm.password.value;
	
		}
	
		if (document.forms.eventLoginForm.email) {
	
			serverData.email = document.forms.eventLoginForm.email.value;
			
		}

	}

	$.ajax({

		type: 'POST',
		dataType: 'JSON',
		url: endpoint,
		data: serverData

	}).done(function(response) {

		triggerCustomEvent(response.status.detail, {
			data: {
				response: response
			}
		});

	});

};

var addEventHandlers = function() {

	appDom.document.on('event_login_invalid', function(e, data) {

		showErrorMessage({
			target: document.forms.eventLoginForm.password,
			msg: data.response.status.msg
		});

	});
	
	appDom.document.on('event_login_invalid_email', function(e, data) {

		showErrorMessage({
			target: document.forms.eventLoginForm.email, 
			msg: data.response.status.msg
		});

	});

	appDom.document.on('event_login_account_creation_attempted', function(e, data) {

		console.log('event_login_account_creation_attempted', data);

		// Inject account create form, setup logic to submit and validate to event_login_account_creation_action.cfm (new file), need to duplicate login client var stuff and activity logic from event_login_action.cfm 

		document.forms.eventLoginForm.innerHTML = data.response.markup;
		document.forms.eventLoginForm.dataset.contactCreation = 'true';

		document.forms.eventLoginForm.changeEmailButton.addEventListener('click', function() {

			window.location.reload();

		});

	});

	appDom.document.on('event_login_account_creation_email_not_confirmed', function(e, data) {

		showErrorMessage({
			target: document.forms.eventLoginForm.confirm.nextElementSibling,
			msg: data.response.status.msg,
			position: 'top-left'
		});

	});
	
	appDom.document.on('event_login_account_creation_policy_not_accepted', function(e, data) {

		showErrorMessage({
			target: document.forms.eventLoginForm.policy.nextElementSibling,
			msg: data.response.status.msg,
			position: 'top-left'
		});

	});

	appDom.document.on('event_login_success', function(e, data) {

		routeSuccessfulLogin(data.response.loginDirective);

	});

	document.forms.eventLoginForm.addEventListener('submit', function(e) {

		e.preventDefault();
		attemptLogin();

	});

};

var init = function() {

	addEventHandlers();
	focalPoint.init();

};

module.exports = {

	init: init

};
